import React from "react";
import { withTheme } from "styled-components/native";
import Icon from "./FontAwesomePro";
import { Container } from "../layout/common";

/**
 * This component is created to get a rounded Icon with som kind of
 * backgroundColor but without damaging other components.
 */
const RoundedIcon = ({ theme, backgroundColor, iconSize, ...props }) => (
  <Container
    style={{
      backgroundColor: backgroundColor || theme.arrayIconBackgroundColor,
      borderRadius: theme.arrayIconBackgroundColor && iconSize / 2,
      width: iconSize,
      height: iconSize,
      justifyContent: "center",
      alignItems: "center"
    }}
  >
    <Icon
      iconSize={theme.arrayIconBackgroundColor ? iconSize / 2 : iconSize}
      weight={theme.arrayIconWeight || "solid"}
      {...props}
    />
  </Container>
);

export default withTheme(RoundedIcon);
